const decks = [
  { shortName: 'hiragana', longName: 'Hiragana' },
  { shortName: 'katakana', longName: 'Katakana' },
  { shortName: 'n5', longName: 'JLPT N5' },
  { shortName: 'n4', longName: 'JLPT N4' },
  { shortName: 'n3', longName: 'JLPT N3' },
  { shortName: 'n2', longName: 'JLPT N2' },
  { shortName: 'n1', longName: 'JLPT N1' },
  { shortName: '10k', longName: 'Kanken 10級' },
  { shortName: '9k', longName: 'Kanken 9級' },
  { shortName: '8k', longName: 'Kanken 8級' },
  { shortName: '7k', longName: 'Kanken 7級' },
  { shortName: '6k', longName: 'Kanken 6級' },
  { shortName: '5k', longName: 'Kanken 5級' },
  { shortName: '4k', longName: 'Kanken 4級' },
  { shortName: '3k', longName: 'Kanken 3級' },
  { shortName: 'j2k', longName: 'Kanken 準2級' },
  { shortName: '2k', longName: 'Kanken 2級' },
  { shortName: 'j1k', longName: 'Kanken 準1級' },
  { shortName: '1k', longName: 'Kanken 1級' },
  { shortName: 'prefectures', longName: 'Prefectures' },
  { shortName: 'cities', longName: 'Cities' },
  { shortName: 'myouji', longName: 'Family Names' },
  { shortName: 'namae', longName: 'Given Names' },
  { shortName: 'seiyuu', longName: 'Voice Actor/Actress Names' },
  { shortName: 'countries', longName: 'Countries' },
  { shortName: 'animals', longName: 'Animals' },
  { shortName: 'birds', longName: 'Birds' },
  { shortName: 'bugs', longName: 'Bugs' },
  { shortName: 'fish', longName: 'Fish' },
  { shortName: 'plants', longName: 'Plants' },
  { shortName: 'vegetables', longName: 'Vegetables' },
  { shortName: 'common', longName: 'Common (According to Jisho.org)' },
  { shortName: 'numbers', longName: 'Numbers' },
  { shortName: 'hard', longName: 'Hard' },
  { shortName: 'insane', longName: 'Insane' },
  { shortName: 'yojijukugo', longName: '四字熟語' },
  { shortName: 'kokuji', longName: '国字' },
  { shortName: 'radicals', longName: 'Radicals' },
  { shortName: 'klcc', longName: 'Kodansha Learner\'s Course' },
  { shortName: 'anagrams3', longName: 'English Anagrams Length 3' },
  { shortName: 'anagrams4', longName: 'English Anagrams Length 4' },
  { shortName: 'anagrams5', longName: 'English Anagrams Length 5' },
  { shortName: 'anagrams6', longName: 'English Anagrams Length 6' },
  { shortName: 'anagrams7', longName: 'English Anagrams Length 7' },
  { shortName: 'anagrams8', longName: 'English Anagrams Length 8' },
  { shortName: 'anagrams9', longName: 'English Anagrams Length 9' },
  { shortName: 'anagrams10', longName: 'English Anagrams Length 10+' },
  { shortName: 'ranobe', longName: 'ラノベ Sentences' },
];

export default decks;
